import { styled, theme } from '@notino/react-styleguide';

export const StoreTitle = styled.p`
  ${theme.typography.labelRegular400}
  margin-bottom: 0.25rem;
`;

export const StoreDescription = styled.span`
  font-weight: 300;
  ${theme.typography.labelRegular400}
  color:${theme.palette.neutralDark};
  padding-bottom: 0.25rem;
`;

export const StoreStockAvailabilityWrapper = styled.div`
  color: ${theme.palette.success};
  ${theme.typography.labelRegular400}
`;
